import styled from "styled-components";

export const MainSection = styled.section`
  .container {
    margin-top: 6rem;
    padding-bottom: 3rem;

    @media (max-width: 767px) {
      margin-top: 4rem;
    }
  }

  .main-row {
    margin-top: 4rem;
  }
`;

export const Title = styled.h5`
  color: rgba(61, 64, 68, 0.35);
  text-align: center;
  font-family: "Zen Dots";
  font-size: 58.917px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 58.917px */
  text-transform: capitalize;

  @media (max-width: 767px) {
    font-size: 40px;
  }

  p {
    color: #5ea624;
    text-align: center;
    font-family: "Zen Dots";
    font-size: 29.459px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 29.459px */
    text-transform: capitalize;
    transform: translateY(-1rem);

    @media (max-width: 767px) {
      font-size: 20px;
    }
  }
  &.title2 {
    margin-top: -1.5rem;

    @media (max-width: 990px) {
      margin-top: 5rem;
    }
  }
`;

export const ImgDiv = styled.div`
  margin-top: -8rem;
  margin-left: 4rem;

  @media (max-width: 990px) {
    display: none;
  }
`;

export const Text1 = styled.div`
  margin-top: 2rem;
  @media (max-width: 767px) {
    margin-top: 0rem;
  }
  ul li {
    color: #fff;
    font-size: 15.711px;
    font-style: normal;
    font-weight: 400;
    line-height: 21.603px; /* 137.5% */
    margin-top: 1rem;
  }

  p {
    color: #fff;
    font-size: 15.711px;
    font-style: normal;
    font-weight: 400;
    line-height: 21.603px; /* 137.5% */
    margin-top: 1rem;
  }
`;

export const ImgWrapper = styled.div`
  text-align: center;
  margin-top: 3.5rem;
  &.img-wrapper2 {
    margin-top: 2.5rem;

    @media (max-width: 767px) {
      margin-top: -2rem;
    }
  }

  &.img-wrapper3 {
    margin-top: 5rem;

    @media (max-width: 767px) {
      margin-top: -2rem;
    }
  }
`;

export const ImgDiv2 = styled.div`
  text-align: end;
  margin-right: 10rem;
  margin-top: 2rem;

  @media (max-width: 990px) {
    display: none;
  }
`;

export const Text2 = styled.div`
  span {
    color: #fff;
    font-size: 15.711px;
    font-style: normal;
    font-weight: 700;
    line-height: 21.603px; /* 137.5% */
  }

  p {
    color: #fff;
    font-size: 15.711px;
    font-style: normal;
    font-weight: 400;
    line-height: 21.603px;
  }

  ul li {
    color: #fff;
    font-size: 15.711px;
    font-style: normal;
    font-weight: 400;
    line-height: 21.603px; /* 137.5% */
    margin-top: 1rem;
  }
  h5 {
    color: #77ea1a;
    font-size: 15.711px;
    font-style: italic;
    font-weight: 400;
    line-height: 21.603px; /* 137.5% */
  }

  @media (max-width: 767px) {
    margin-top: 2.5rem;
  }
`;
